import { useLangStore } from "@/entities";
import { UiDropdown, UiSelect, UiShow } from "@/shared/ui";
import { SelectOption } from "@/shared/types.ts";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { capitalize } from "@/shared/utils";
import { getDictionary } from "@/shared/api/dictionary.ts";

type Variant = "dropdown" | "selectable";

interface Props {
  variant?: Variant;
}

export const ChangeLang: FC<Props> = ({ variant = "dropdown" }) => {
  const { data, lang, setLang } = useLangStore();
  const { i18n } = useTranslation();

  const handleSelect = async ({ value }: SelectOption) => {
    const newDictionary = await getDictionary(value);
    i18n.addResources(value, "translation", newDictionary);
    await i18n.changeLanguage(value);
    setLang(value);
  };

  return (
    <UiShow>
      <UiShow.When isTrue={variant == "dropdown"}>
        <UiDropdown
          onSelect={handleSelect}
          defaultValue={lang}
          options={data.map((item) => ({
            name: capitalize(item.label),
            value: item.lang,
          }))}
        />
      </UiShow.When>
      <UiShow.When isTrue={variant == "selectable"}>
        <UiSelect
          onSelect={handleSelect}
          defaultValue={lang}
          options={data.map((item) => ({
            name: capitalize(item.label),
            value: item.lang,
          }))}
        />
      </UiShow.When>
    </UiShow>
  );
};
